// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accueilContainer{
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    background: #0C0B20;
    background-size: cover;
    padding-bottom: 120px;
    padding-top: 64px;
    align-items: center;
}


/* EVAN */

.accueilContainer h2{
    color: white;
    margin-bottom: 16px;
    text-align: center;
}

.headWithSpace{
    margin-top: 100px;
}

.subscribeBtn{
    color: white!important;
    font-size: 25px!important;
    font-weight: bold!important;
    border: 5px solid #C3D32C!important;
    cursor: pointer!important;
}

@media (max-width: 500px) { 
    /* Styles pour les écrans de moins de 400px */
    .subscribeBtn {
        width: 100%!important;
    }
  }
  


/* FIN EVAN */

.tournamentsWraper{
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    padding: 12px 20px;
    max-width: 500px;
}

.homeLogo{
    height: 150px;
    width: 100%;
    object-fit: contain;
    padding: 0;
    margin-bottom: 16px;
}

.howItWorks{
    display: flex;
    flex-direction: column;
    padding: 12px 20px;
    gap: 8px;
    width: 100%;
    max-width: 500px;
    align-items: center;
}


.howItWorks p{
    color: #FFF;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 100%; /* 12px */
}

.howItWorks button{
    display: flex;
height: 48px;
width: 70%;
padding: 16px;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 39px;
border: 2px solid #C3D32C;
background: none;
color: #C3D32C;
font-size: 16px;
font-family: Lato;
font-weight: 700;
letter-spacing: 1.82px;
}

.infosBtn, .contactBtn{
    cursor: pointer;
    margin: 16px 0px;
    display: flex;
height: 48px;
width: 100%;
padding: 16px;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 39px;
border: 2px solid #C3D32C;
background: none;
color: #C3D32C;
font-size: 16px;
font-family: Lato;
font-weight: 700;
letter-spacing: 1.82px;
}

.howItWorks button:nth-child(1){
    margin: 8px 0;
}

.homeLoginContainer {
    text-align: right;
    padding: 24px;
    position: absolute;
    top: 0;
    right: 0;
  }
  
  .homeLoginButton {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border: 2px solid #c3d32c;
    color: white;
    padding: 8px;
    border-radius: 100%;
    cursor: pointer;
    font-size: 16px;
    background: none;
  }
  
  .no-tournaments-message {
    text-align: center;
    font-size: 1.2em;
    color: white;
    margin-top: 20px;
  }`, "",{"version":3,"sources":["webpack://./src/assets/Styles/Accueil.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;AACvB;;;AAGA,SAAS;;AAET;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,2BAA2B;IAC3B,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;IAC7C;QACI,qBAAqB;IACzB;EACF;;;;AAIF,aAAa;;AAEb;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,WAAW;AACf,iBAAiB;AACjB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,SAAS;AAC5B;;AAEA;IACI,aAAa;AACjB,YAAY;AACZ,UAAU;AACV,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,QAAQ;AACR,mBAAmB;AACnB,yBAAyB;AACzB,gBAAgB;AAChB,cAAc;AACd,eAAe;AACf,iBAAiB;AACjB,gBAAgB;AAChB,sBAAsB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB,YAAY;AACZ,WAAW;AACX,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,QAAQ;AACR,mBAAmB;AACnB,yBAAyB;AACzB,gBAAgB;AAChB,cAAc;AACd,eAAe;AACf,iBAAiB;AACjB,gBAAgB;AAChB,sBAAsB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB","sourcesContent":[".accueilContainer{\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    min-height: 100vh;\r\n    background: #0C0B20;\r\n    background-size: cover;\r\n    padding-bottom: 120px;\r\n    padding-top: 64px;\r\n    align-items: center;\r\n}\r\n\r\n\r\n/* EVAN */\r\n\r\n.accueilContainer h2{\r\n    color: white;\r\n    margin-bottom: 16px;\r\n    text-align: center;\r\n}\r\n\r\n.headWithSpace{\r\n    margin-top: 100px;\r\n}\r\n\r\n.subscribeBtn{\r\n    color: white!important;\r\n    font-size: 25px!important;\r\n    font-weight: bold!important;\r\n    border: 5px solid #C3D32C!important;\r\n    cursor: pointer!important;\r\n}\r\n\r\n@media (max-width: 500px) { \r\n    /* Styles pour les écrans de moins de 400px */\r\n    .subscribeBtn {\r\n        width: 100%!important;\r\n    }\r\n  }\r\n  \r\n\r\n\r\n/* FIN EVAN */\r\n\r\n.tournamentsWraper{\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 32px;\r\n    width: 100%;\r\n    padding: 12px 20px;\r\n    max-width: 500px;\r\n}\r\n\r\n.homeLogo{\r\n    height: 150px;\r\n    width: 100%;\r\n    object-fit: contain;\r\n    padding: 0;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.howItWorks{\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 12px 20px;\r\n    gap: 8px;\r\n    width: 100%;\r\n    max-width: 500px;\r\n    align-items: center;\r\n}\r\n\r\n\r\n.howItWorks p{\r\n    color: #FFF;\r\nfont-family: Lato;\r\nfont-size: 16px;\r\nfont-style: normal;\r\nfont-weight: 700;\r\nline-height: 100%; /* 12px */\r\n}\r\n\r\n.howItWorks button{\r\n    display: flex;\r\nheight: 48px;\r\nwidth: 70%;\r\npadding: 16px;\r\njustify-content: center;\r\nalign-items: center;\r\ngap: 4px;\r\nborder-radius: 39px;\r\nborder: 2px solid #C3D32C;\r\nbackground: none;\r\ncolor: #C3D32C;\r\nfont-size: 16px;\r\nfont-family: Lato;\r\nfont-weight: 700;\r\nletter-spacing: 1.82px;\r\n}\r\n\r\n.infosBtn, .contactBtn{\r\n    cursor: pointer;\r\n    margin: 16px 0px;\r\n    display: flex;\r\nheight: 48px;\r\nwidth: 100%;\r\npadding: 16px;\r\njustify-content: center;\r\nalign-items: center;\r\ngap: 4px;\r\nborder-radius: 39px;\r\nborder: 2px solid #C3D32C;\r\nbackground: none;\r\ncolor: #C3D32C;\r\nfont-size: 16px;\r\nfont-family: Lato;\r\nfont-weight: 700;\r\nletter-spacing: 1.82px;\r\n}\r\n\r\n.howItWorks button:nth-child(1){\r\n    margin: 8px 0;\r\n}\r\n\r\n.homeLoginContainer {\r\n    text-align: right;\r\n    padding: 24px;\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n  }\r\n  \r\n  .homeLoginButton {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 8px;\r\n    border: 2px solid #c3d32c;\r\n    color: white;\r\n    padding: 8px;\r\n    border-radius: 100%;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    background: none;\r\n  }\r\n  \r\n  .no-tournaments-message {\r\n    text-align: center;\r\n    font-size: 1.2em;\r\n    color: white;\r\n    margin-top: 20px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
